import { Component } from '@angular/core';

@Component({
  selector: 'app-out-of-order',
  templateUrl: './out-of-order.component.html',
  styleUrls: ['./out-of-order.component.scss'],
})
export class OutOfOrderComponent {}
